import Messages from "../Messages";

import { FiPhoneCall } from "react-icons/fi";
import { Link } from "react-router-dom";
import useSharedData from "../../../../../hooks/useSharedData";
import style from "./NavProfile.module.css";
import HamburgerMenu from "./components/HamburgerMenu";
import LoginUserMenu from "./components/LoginUserMenu";
import Signup from "./components/Signup";

function NavProfile() {
  const { isAuthed } = useSharedData();

  return (
    <section className="d-flex align-items-center column-gap-1">
      <div className="text-primary d-none d-md-block">
        <span className={"ms-2 " + style.phoneIcon}>
          <FiPhoneCall />
        </span>
        <span>
          <Link to="tel:02182802466">021-82802466</Link>
        </span>
      </div>
      {isAuthed && <Messages />}
      {isAuthed && <LoginUserMenu />}
      {isAuthed === false && <Signup />}
      <HamburgerMenu />
    </section>
  );
}

export default NavProfile;
